import styled from 'styled-components/macro';
import {
    Button,
    Checkbox,
    FormControl,
    FormLabel,
    Input,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    useToast,
} from "@chakra-ui/react";
import {useFeedback} from "../../../store/feedback";
import {useState} from "react";
import {useAddModerator} from "../../../api/moderation";
import {themecolors} from "../../../utils/themecolors";
import {ChevronDown, ChevronUp} from "lucide-react";

const Toggle = styled.div``;

const NewModerator = styled(({className, community, setTime, onClose}) => {
    const [showPermissions, setShowPermissions] = useState(false);
    const [moderator, setModerator] = useState({
        community: community,
        author: '',
        all_permissions: false,
        manage_rules: false,
        manage_automoderator: false,
        manage_settings: false,
        manage_stylesheet: false,
        manage_sidebar: false,
    });
    const set = (name) => (value) => setModerator((moderator) => ({...moderator, [name]: value}));
    const {feedbackCh} = useFeedback();
    const toast = useToast();
    const addModerator = useAddModerator(feedbackCh);
    const [saving, setSaving] = useState(false);
    const handleSave = async () => {
        setSaving(true);
        await addModerator(moderator);
        toast({
            title: `Successfully added!`,
            status: 'success',
            isClosable: true,
        });
        setTime(Date.now());
        setSaving(false);
        onClose();
    };
    return (
        <Modal
            isOpen
            onClose={onClose}
        >
            <ModalOverlay/>
            <ModalContent>
                <ModalHeader>Add Moderator</ModalHeader>
                <ModalCloseButton/>
                <ModalBody pb={6} className={className}>
                    <FormControl>
                        <FormLabel>Username</FormLabel>
                        <Input
                            value={moderator.author}
                            onChange={(e) => set('author')(e.currentTarget.value)}
                            maxLength="64"
                            autoComplete="off"
                            type="text"
                            required
                            mb={'10px'}
                        />
                    </FormControl>
                    <Toggle onClick={() => setShowPermissions(!showPermissions)}>
                        {showPermissions ? 'Hide' : 'Show'} Permissions Settings
                        {showPermissions ?
                            <ChevronUp size={20} />
                        :
                            <ChevronDown size={20} />
                        }
                    </Toggle>
                    {showPermissions &&
                    <>
                        <FormControl pb={1} pt={4}>
                            <Checkbox size='md' value={moderator.all_permissions}
                                      onChange={(e) => set('all_permissions')(e.target.checked)}>All Permissions</Checkbox>
                        </FormControl>
                        <FormControl pb={1}>
                            <Checkbox size='md' value={moderator.manage_rules}
                                      onChange={(e) => set('manage_rules')(e.target.checked)}>Manage Rules</Checkbox>
                        </FormControl>
                        <FormControl pb={1}>
                            <Checkbox size='md' value={moderator.manage_sidebar}
                                      onChange={(e) => set('manage_sidebar')(e.target.checked)}>Manage Sidebar</Checkbox>
                        </FormControl>
                        <FormControl pb={1}>
                            <Checkbox size='md' value={moderator.manage_automoderator}
                                      onChange={(e) => set('manage_automoderator')(e.target.checked)}>Manage Filter</Checkbox>
                        </FormControl>
                        <FormControl pb={1}>
                            <Checkbox size='md' value={moderator.manage_settings}
                                      onChange={(e) => set('manage_settings')(e.target.checked)}>Manage Settings</Checkbox>
                        </FormControl>
                        <FormControl>
                            <Checkbox size='md' value={moderator.manage_stylesheet}
                                      onChange={(e) => set('manage_stylesheet')(e.target.checked)}>Manage Stylesheet</Checkbox>
                        </FormControl>
                    </>
                    }
                </ModalBody>
                <ModalFooter>
                    <Button variant="cancel" mr={3} onClick={onClose}>
                        Cancel
                    </Button>
                    <Button variant="blue" onClick={handleSave} isLoading={saving}>
                        Save
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    )
})`
  ${Toggle} {
    font-size: 15px;
    display: flex;
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.pure_white : theme.placeholder_link_2};
    cursor: pointer;
  }

  ${Toggle} svg {
    margin-left: auto;
  }
`;

export default NewModerator;
